import { Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutRetransmitStatusModal extends Layout {
    labelRetransmit: Label;
    retransmitPanel: Panel;
}
